import React from "react";
import CardContentItem from "@/components/cards/cardContent/cardContent";
import { CardSection as CardSectionType, ContentCard } from "@/types/cms";
import { cn } from "@/lib/utils";
import { cardImageSizes } from "@/lib/cardImageSizes";
import styles from "./cardsGrid.module.css";

type CardSectionTypeEnum = CardSectionType['type'];

interface CardsGridProps {
  type?: CardSectionTypeEnum;
  cards: ContentCard[];
  shadow?: boolean;
  variant?: "default" | "testimonial" | "price" | "lesson" | "agentAvatar";
  getCardVariant?: (card: ContentCard) => "default" | "testimonial" | "price" | "lesson" | "agentAvatar";
}

const CardsGrid = ({
  type = "type_3up",
  cards,
  shadow = false,
  variant,
  getCardVariant,
}: CardsGridProps) => {
  let layoutClass: string;

  switch (type) {
    case 'type_4up':
      layoutClass = styles.type4up;
      break;
    case 'type_2up50/50':
      layoutClass = styles.type2up;
      break;
    case 'type_1up':
      layoutClass = styles.type1up;
      break;
    case 'type_1up100vh':
      layoutClass = styles.type1up100vh;
      break;
    case 'type_2up60/40':
      layoutClass = styles.type2up60_40;
      break;
    case 'type_2up40/60':
      layoutClass = styles.type2up40_60;
      break;
    default:
      layoutClass = styles.typeDefault;
      break;
  }

  const imageSizes = cardImageSizes(type);

  return (
    <div className={cn(styles.grid, layoutClass)}>
      {cards.map((card, idx) => (
        // The reveal wrapper IS the grid cell — deliberately, so the stagger
        // costs no extra nesting inside the card. `.cell` re-passes the grid's
        // `align-items: stretch` down to the card, which used to be the grid
        // item itself. Index starts at 1 because the section header is 0.
        // Inert outside a `SectionReveal`; see documentation/loading-animations.md.
        <div
          key={card.id ?? `${idx}-${card.header || 'card'}`}
          className={cn("reveal-item", styles.cell)}
          style={{ "--reveal-index": idx + 1 } as React.CSSProperties}
        >
          <CardContentItem
            card={card}
            shadow={shadow}
            variant={getCardVariant ? getCardVariant(card) : variant}
            imageSizes={imageSizes}
          />
        </div>
      ))}
    </div>
  );
};

export default CardsGrid;


